import React from 'react';
import {ModelActionProps} from '../../../../actionMenuTypes';
import {MODEL_ACTION_MENU_IDS} from '../../../../../../test/types';
import SideBarButtonItem from '../../../../../layout/common/SideBarButtonItem';
import {tid} from '../../../../../../testUtils';
import {canEditModel} from '../../../../../../permissions/usePermissions';
import {useModelEditFilesSideBarModal} from './useModelEditFilesSideBarModal';
import {Folder16} from '@carbon/icons-react';
import {FolderOutlined} from '@ant-design/icons';
import {getUrlRoute, MRAppRoutes} from '../../../../../router/routes';
import {useNavigate} from 'react-router-dom';

const ModelEditFilesActionMenuButton: React.FC<Partial<ModelActionProps>> = (props) => {
  const navigate = useNavigate();
  const {ModalComponent, openModal} = useModelEditFilesSideBarModal(props);
  const handleClick = () => {
    if (props.newDesign && props.model?.uuid) {
      navigate(
        getUrlRoute(MRAppRoutes.MODEL_UPLOAD, {
          uuid: props.model.uuid,
          editMode: 'true',
          editStep: 'files',
        } as any),
      );
      return;
    }
    openModal();
  };

  return (
    <>
      <SideBarButtonItem
        {...tid(MODEL_ACTION_MENU_IDS.EDIT_FILES)}
        permission={canEditModel(props.model)}
        onClick={handleClick}
        icon={props.newDesign ? <FolderOutlined /> : <Folder16 />}
        text="Edit Files"
      />
      {!props.newDesign && ModalComponent}
    </>
  );
};

export default ModelEditFilesActionMenuButton;
